export const API_BASE_URL = "https://api.cryptootc.iosx.in/api/v1/";
export const API_IMAGE_URL = "https://api.cryptootc.iosx.in/";
export const SOCKET_URL = "https://api.cryptootc.iosx.in/";
// export const API_BASE_URL = "http://192.168.0.131:3666/api/v1";
// export const SOCKET_URL = "http://192.168.0.131:3666";

// export const API_BASE_URL = "http://127.0.0.1:9956/api/v1/";
// export const SOCKET_URL = "http://127.0.0.1:9956";